import "./App.css";
import { Outlet } from "react-router-dom";
import { GlobalNotification } from "./Components/GlobalNotification";
import AuthBridge from "./Components/AuthBridge";

function App() {
  return (
    <>
      <AuthBridge />
      <GlobalNotification />
      <Outlet />
    </>
  );
}

export default App;
